/* tslint:disable:no-console */

export function getWindowSize(): { width: number; height: number } {
  return {
    height: window.innerHeight,
    width: window.innerWidth
  };
}

export function getMraidWindowSize(): { width: number; height: number } {
  if (window.mraid) {
    const size = window.mraid.getScreenSize();
    if (size.width !== 0 && size.height !== 0) {
      return size;
    }
  }
  return getWindowSize();
}
